<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import SideBar from "@views/pages/mindmap/overlay/side-bar"
import SkillsTable from '@components/skills-table'
import requestFunctions from "@src/functions/requestFunctions"
import MindMap from "@views/pages/mindmap/mind-map"
import SkillsCard from "@components/skills-card"
import Header from "@views/pages/mindmap/overlay/header"
import DocBar from "@views/pages/mindmap/overlay/doc-bar"
import MindMapTestForm from "@views/pages/mindmap/mind-map-test-form"
import BotForm from "@components/bot-form"
import SkillForm from "@components/skill-form"
import BotChannels from "@components/bot-channels"
import {actionTypePath} from "@src/functions/reteEditor"

const buildBlock = (id, type, position, sockets, additional) => ({
  id: id,
  parents_id: [],
  actions_code: [],
  action: type || null,
  description: null,
  message_send: {},
  audio: {},
  record: {},
  stt_params: {},
  tts_params: {},
  digital_input_params: {},
  voicemail_detection_params: {},
  text: null,
  intent: {},
  condition: {},
  http_request_params: {},
  set_variables: null,
  ai_request_params: {},
  event_wait_params: {},
  call_redirect_params: {},
  childs: [],
  position,
  sockets,
  ...additional
})

export default {
  components: {Header, SkillsCard, MindMap, SideBar, DocBar, MindMapTestForm, BotForm, SkillForm, Layout, SkillsTable, BotChannels},

  page: {
    title: 'Редактор сценариев',
    meta: [{ name: 'mindmap', content: appConfig.description }],
  },

  data() {
    return {
      bot_uuid: null,
      track: [],
      skill_uuid: null,
      owner_id: null,
      user_id: null,
      cntBlocks: 0,
      blocks: [],
      selectedBlock: {
        visible: false,
        id: 0,
        type: '',
        data: {}
      },
      source: {
        visible: false,
        type: null,
        uuid: null,
        title: '',
        description: '',
        other: null
      },
      testCall: {
        visible: false
      },
      modal: {
        visible: false,
        title: null,
        type: null
      },
      freeze: false,
      fl_ai: false,
      skill_name: '',
      skill_description: '',
      saveModal: false,
      loadModal: false,
      success_save_modal: false,
      success_save_modal_text: '',
      key: 0,
      showSidebarChannels: false
    }
  },

  async mounted() {
    this.source.uuid = this.$route.params.skill_uuid

    if(this.$route.params.track){
      this.track = this.$route.params.track
    }
    if ('type' in this.$route.params && this.$route.params.type === 'skill'){
      this.skill_uuid = this.$route.params.uuid;
    }
    if ('type' in this.$route.params && this.$route.params.type === 'bot') {
      this.bot_uuid = this.$route.params.uuid;
    }
    await this.fetchData(true)    
  },

  computed: {
    skill_item(){
        return this.$store.getters['skills/GET_SKILLS_ITEM'];
    },
    session_user_item(){
        let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
        return session.user ? session.user : null;
    },
  },

  methods: {
    async fetchData(getMindMap = false){

      const {type, name, description, mind_map, mind_map_cnt, owner_id, user_id, fl_ai, ...other} = await (async () => {
        if ('type' in this.$route.params && this.$route.params.type === 'skill'){
          await this.$store.dispatch('skills/FETCH_SKILLS_ITEM', {uuid: this.$route.params.uuid})
          return {...this.$store.getters['skills/GET_SKILLS_ITEM'], type: 'skill'}
        }
        if ('type' in this.$route.params && this.$route.params.type === 'bot') {
          await this.$store.dispatch('bots/FETCH_BOTS_ITEM', {uuid: this.$route.params.uuid});
          return {...this.$store.getters['bots/GET_BOTS_ITEM'], type: 'bot'};
        }
        return {name: '', description: '', mind_map: '', mind_map_cnt: 0, type: 'empty', fl_ai: false}
      })()

      this.owner_id = owner_id;
      this.user_id = user_id;
      this.fl_ai = fl_ai;
      this.source = {
        ...this.source,
        title: name,
        description,
        type,
        ...other
      }

      if (!getMindMap) return

      if (mind_map_cnt) this.cntBlocks = mind_map_cnt    
      if (mind_map) this.blocks = JSON.parse(mind_map)
      
      if (this.cntBlocks === 0) this.addBlock('call', [0, 0], {}, true)

      else { // Поддержка старых схем чья модель потомков устарела
        this.blocks.map(block => {
          if (!Array.isArray(block.childs))
            block.childs = []
        })
      }
      await this.$refs.mindMapRef.mindMapInit(this.fl_ai)
      await this.$refs.mindMapRef.mindMapRender(this.blocks)
    },

    isConditionAction(action) {
      for (const key of Object.keys(actionTypePath)){
        if (key === action) return true
      }
      return false
    },

    // Возвращает последний созданный блок который который соответствует type = ['default'] || ['condition']
    searchLastCreatedBlock(type = 'default', shift = 1) {
      if (this.blocks.length === 0 || shift === this.blocks.length) return {position: [0, 0]}

      const lastBlock = this.blocks[this.blocks.length - shift]

      if (lastBlock && type === 'condition' && this.isConditionAction(lastBlock.action))
        return lastBlock

      else if (lastBlock && type === 'default' && !this.isConditionAction(lastBlock.action))
        return lastBlock

      else
        return this.searchLastCreatedBlock(type, shift + 1)
    },

    addBlock(type, position, additional = {}, noRender = false) {
      let sockets = {
        outputs: ['default'],
        inputs: ['input']
      };
      const disableOutput = () => {
        sockets = {...sockets, outputs: []};
      }
      const disableInput = () => {
        sockets = {...sockets, inputs: []};
      }

      switch (type) {
        case 'call': disableInput(); break;
        case 'end_call': disableOutput(); break;
      }

      // если позиция не задана, пытаемся найти последний созданный блок и позиционируемся под ним
      if (!position){
        const lastBlock = this.searchLastCreatedBlock('default')
        if (lastBlock) {
          position = [...lastBlock.position]
          position[1] += 144
        }
      }

      this.cntBlocks++
      const index = this.blocks.push(buildBlock(this.cntBlocks, type, position, sockets, additional));

      if (!noRender)
        this.$refs.mindMapRef.mindMapRender()

      return this.blocks[index - 1]
    },

    // deleteBlock(id, noRender = false) {
    //   console.log(id);

    //   const currentBlockIndex = this.blocks.findIndex(block => block.id === id)
    //   const currentBlock = this.blocks[currentBlockIndex]

    //   // Если у удаляемого блока есть указатели на логические блоки, удаляем логические блоки
    //   if (currentBlock.childs && currentBlock.childs.length) {
    //     currentBlock.childs.map(child => {
    //       if (child.type.includes('to_'))
    //         this.deleteBlock(child.id, true)
    //     })
    //   }

    //   // Ищем блоки, которые ссылаются на удаляемый
    //   // this.blocks.map(block => {
    //   //     if ('childs' in block && block.childs.length){
    //   //       block.childs = block.childs.filter((child) => child.id !== id)
    //   //     }
    //   //     // если на удаляемый блок ссылался логический и больше ему не на что ссылаться удаляем его и указатель на него
    //   //     if ((block.action === 'intent' || block.action === 'condition') && 'childs' in block && !block.childs.length){
    //   //       const instanceBlock = this.blocks.find(block_ => block_.id === block.instanceId)
    //   //       instanceBlock.childs = instanceBlock.childs.filter(child => child.id !== block.id)
    //   //       this.deleteBlock(block.id, true)
    //   //       // this.deleteBlock(instanceBlock.id, true)
    //   //     }
    //   // })

    //   this.blocks.forEach((block, index) => {
    //     if ('childs' in block && Array.isArray(block.childs) && block.childs.length) {
    //       this.blocks[index].childs = block.childs.filter((child) => child.id !== id);
    //     }

    //     if ((block.action === 'intent' || block.action === 'condition') && 'childs' in block && Array.isArray(block.childs) && !block.childs.length) {
    //       const instanceBlock = this.blocks.find((block_) => block_.id === block.instanceId);

    //       if (instanceBlock && 'childs' in instanceBlock && Array.isArray(instanceBlock.childs)) {
    //         this.blocks[index].childs = instanceBlock.childs.filter((child) => child.id !== block.id);
    //         this.deleteBlock(block.id, true);
    //       }
    //     }
    //   });

    //   this.blocks.splice(currentBlockIndex, 1);

    //   if (!noRender)
    //     this.$refs.mindMapRef.mindMapRender()
    //   return false;
    // },

    deleteBlock(id, noRender = false, comment = '') {

      // console.log('deleteBlock: ' + id  + ' - ' + comment);
        
      const currentBlockIndex = this.blocks.findIndex(block => block.id === id)
      const currentBlock = this.blocks[currentBlockIndex]

      // Ищем элемент из которого она выходит и затираем элемент в childs
      this.blocks.forEach((block, index) => {
        if ('childs' in block && Array.isArray(block.childs) && block.childs.length) {
          this.blocks[index].childs = block.childs.filter((child) => child.id !== id);
        }
      });

      // Если элемент является стрелкой
      if(currentBlock.instanceId){
        // console.log('Удаляем стрелку');
        
      } else {
        // Если элемент является блоком
        // console.log('Удаляем блок');
        // Ищем входящие стрелки и удаляем их
        let instanceBlocks = this.blocks.filter((block) => block.instanceId === id);
        instanceBlocks.forEach((block, index) => {
          this.deleteBlock(block.id, true, '1')
        });
        // Ищем исходящие стрелки и удаляем их
        if (currentBlock.childs && currentBlock.childs.length) {
          currentBlock.childs.map(child => {
            if (child.type.includes('to_'))
              this.deleteBlock(child.id, true, '2')
          })
        }
      }
      
      // Удаляем сам элемент из массива
      this.blocks.splice(currentBlockIndex, 1);

      if (!noRender)
        this.$refs.mindMapRef.mindMapRender()
      return false;
    },

    createPath({ id, child }) {
      const { instanceBlock } = this.getConditionPathStructure(id)
      const newChild = {
        type: 'default',
        id: child,
        priority: 1
      }

      instanceBlock.childs.push(newChild)

      this.$refs.mindMapRef.mindMapRender()
    },

    removePath({ id, child }) {
      let parentBlock = this.blocks.find(block => block.id === id)
      // ищем если это указатель
      const signToConditionBlock = parentBlock.childs.length && parentBlock.childs
          .find((child_) => child_.type.includes('to_') && 'nestedChilds' in child_ && child_.nestedChilds.includes(child))
      // Если путь является логическим, сначала сбрасываем до обычного
      if (signToConditionBlock){
        this.changePathType({
          instanceId: id,
          childId: child,
          type: 'default'
        }, false)
      }
      // после чего спокойно можно удалить
      parentBlock.childs = parentBlock.childs.filter(child_ => child_.id !== child)

      this.$refs.mindMapRef.mindMapRender()
    },

    applyBlockEdit(changedBlock) {
      let targetBlockId = null
      // Если тип пути изменился с логического на обычный, сбрасываем
      if (this.selectedBlock.type === 'condition' && changedBlock.action === 'default') {
        this.changePathType({
          instanceId: this.selectedBlock.instanceId,
          childId: changedBlock.path.childId,
          type: changedBlock.action,
        },false)
        this.selectedBlock.type = 'path'
      }

      // Если путь был обычным, а стал логическим, меняем его тип
      if (this.selectedBlock.type === 'path' && changedBlock.action !== 'default') {
        targetBlockId = this.changePathType({
          instanceId: changedBlock.path.parentId,
          childId: changedBlock.path.childId,
          type: changedBlock.action,
        }, false)
        this.selectedBlock.type = 'condition'
      }

      // Если новый логический блок не создавался, меняем тот блок, что передали изначально
      if (!targetBlockId) targetBlockId = changedBlock.id

      // Вычисленный индекс целевого блока
      const targetBlockIndex = this.blocks.findIndex(block => block.id === targetBlockId)

      if (targetBlockIndex !== -1 && changedBlock.action !== 'default'){
        this.blocks[targetBlockIndex] = {...this.blocks[targetBlockIndex], ...changedBlock, id: this.blocks[targetBlockIndex].id}
        if (changedBlock.path){
          const targetChild = this.blocks[targetBlockIndex].childs.find(child => child.id === changedBlock.path.childId)
          targetChild.priority = changedBlock.path.priority
        }
      }
      this.closeSidebar()
    },

    changePathType({instanceId, childId, type, }, render = true) {
      const {instanceBlock, conditionBlock} = this.getConditionPathStructure(instanceId, childId)
      let newConditionBlock = null
      // Если указатель на логический блок есть, путь сначала необходимо преобразовать в default
      if (conditionBlock) {
        // Удаляем указатель из инстанса на этот логический блок
        instanceBlock.childs = instanceBlock.childs.filter(child => !('nestedChilds' in child && child.nestedChilds.includes(childId)))
        // Добавляем не логический указатель
        instanceBlock.childs.push(...conditionBlock.childs.map(child => ({
          id: child.id,
          priority: child.priority,
          type
        })))
        // удаляем уже ненужный логический блок
        this.deleteBlock(conditionBlock.id, true)
      }

      // Если изменяемый тип логический
      if (type !== 'default') {
        // Создать логический блок
        newConditionBlock = this.addBlock(type, [0,0], {instanceId}, true);
        // Добавляем в логический блок единственного потомка по ид инициировавшего событие
        newConditionBlock.childs.push({
          id: childId,
          type: type,
          priority: 1
        })
        // У родительского блока этого потомка меняем на указатель на логический блок
        instanceBlock.childs.map(child => {
          if (child.id === childId){
            child.id = newConditionBlock.id
            child.type = 'to_' + type
            child.nestedChilds = [childId]
          }
        })
      }
      if (render) this.$refs.mindMapRef.mindMapRender()

      if (newConditionBlock) return newConditionBlock.id
    },

    getConditionPathStructure(instanceId, childId) {
      let conditionBlock = null;
      let targetPath = null
      // Получаем ссылку на реальный блок
      const instanceBlock = this.blocks.find(block => block.id === instanceId)

      if (!childId) return {instanceBlock}

      // среди потомков инстанса ищем указатель на логический блок который ссылается на нужного нам потомка
      const pointerChildToCondition = instanceBlock.childs.find(child => 'nestedChilds' in child && child.nestedChilds.includes(childId))

      if (pointerChildToCondition){
        conditionBlock = this.blocks.find(block => block.id === pointerChildToCondition.id)
      }

      if (conditionBlock && conditionBlock.childs.length) {
        targetPath = conditionBlock.childs.find(child => child.id === childId)
      }
      else if (instanceBlock.childs.length){
        targetPath = instanceBlock.childs.find(child => child.id === childId)
      }

      return {instanceBlock, conditionBlock, pointerChildToCondition, targetPath}
    },

    editPath({instanceId, path}) {
      const {instanceBlock, conditionBlock, targetPath} = this.getConditionPathStructure(instanceId, path.connection.input.node.id)
      const block = conditionBlock || instanceBlock
      let type = 'condition'

      if (path.connection.data.type === 'default')
        type = 'path'

      this.selectedBlock = {
        type, instanceId,
        visible: true,
        id: block ? block.id : null,
        data: {
          block: conditionBlock && block,
          path: targetPath
        }
      }

      this.freeze = true
    },

    async closeSidebar(render = true) {
      this.freeze = false;      
      this.selectedBlock.visible = false;
      this.showSidebarChannels = false;
      if (render)
        this.$refs.mindMapRef.mindMapRender()
    },

    setBlockPosition({blockId, position}) {
      const block = this.blocks.find(block => block.id === blockId)
      block.position = position
    },

    editBlock(index, id) {
      const block = this.blocks.find(block => block.id === id)
      this.selectedBlock = {
        id,
        visible: true,
        type: 'default',
        data: { block }
      }
      this.freeze = true
    },

    async saveMap(redirect = true) {
      
      let data_send = {
        'name': this.name,
        'description': this.description,
        'mind_map': JSON.stringify(this.blocks),
        'mind_map_cnt': this.cntBlocks,
        'uuid': this.source.uuid,
      }

      let result = ''

      if (this.source.type === 'skill'){
        result = await this.$store.dispatch('skills/FETCH_SKILLS_UPDATE', data_send);
        if (result === false) return alert('Возникла ошибка')
        if (redirect) this.$router.push({name: 'Skills'})
      }

      if (this.source.type === 'bot') {
        data_send = {...data_send, ...this.source.other}
        result = await this.$store.dispatch('bots/FETCH_BOTS_UPDATE', data_send);
        if (result === false) return alert('Возникла ошибка')
        if (redirect) this.$router.push({name: 'Bots'})
      }
    },

    async testingMap({phone, firstName, middleName, lastName, variables, attempts, time_retries, delayed_at, status, trunk_id}) {
      await this.saveMap(false)
      
      var sendVariables = {};

      if(variables !== ''){
          sendVariables = JSON.parse(variables);
      }

      sendVariables['first_name']  = firstName;
      sendVariables['middle_name'] = middleName;
      sendVariables['last_name']   = lastName;
      sendVariables['phone']       = phone;

      const bot_uuid = this.source.type === 'bot' ? this.source.uuid : ''

      const data_send = {
        'contact_phone': phone,
        'variables': JSON.stringify(sendVariables),
        'attempts': attempts,
        'time_retries': time_retries,
        'delayed_at': delayed_at,
        'bot_uuid': bot_uuid,
        'trunk_id': trunk_id,
        'status': status
      }

      await this.$store.dispatch('calls/FETCH_CALLS_CREATE', data_send)

      this.switchModal('close')
    },

    switchModal(action, type, reload = false) {
      this.modal.visible = action === 'open'
      if (type) {
        this.modal.type = type === 'testing' ? type : 'edite_' + this.source.type
        this.modal.title = (type === 'testing' ? 'Тестирование' : 'Редактирование') + ' ' + (this.source === 'skill' ? 'сценария' : 'бота')
      }
      if (reload) this.fetchData()
    },

    async loadSkill(uuid) {

      let data_send = {
          'uuid' : uuid
      }

      await this.$store.dispatch('skills/FETCH_SKILLS_ITEM', data_send);

      let blocks = this.skill_item.mind_map ? JSON.parse(this.skill_item.mind_map) : null;

      // Копируем файлы в bots

      let type = '';
      let path_to = '';
      let attaching_uuid = '';
      let attaching_type = '';
      if(this.bot_uuid === null){
        type = 'skills';
        path_to = this.skill_uuid;
        attaching_uuid = this.skill_uuid;
        attaching_type = 'skills';
      } else {
        type = 'bots';
        path_to = this.bot_uuid;
        attaching_uuid = this.bots_uuid;
        attaching_type = 'bots';
      }

      for (const el of blocks) {
          if(el.audio.filename && el.audio.filename !== null){
              // копируем физически
              data_send = {
                  attaching_type_to   : type,
                  attaching_type_from : 'skills',
                  path_to   : path_to,
                  path_from : el.audio.path,
                  filename  : el.audio.filename,
                  action    : 'copy'
              }

              let query_url = 'https://api.client.za-bota.com/uploads/';
              let response = await requestFunctions.sendDataAsync(query_url, data_send, 'POST');

              // создаем в базе с новым path
              data_send = {
                  title    : el.audio.title,
                  path     : path_to,
                  status   : 'success',
                  filename : el.audio.filename,
                  ext      : el.audio.ext,
                  attaching_uuid : attaching_uuid,
                  attaching_type : attaching_type
              }

              let new_file = await this.$store.dispatch('files/FETCH_FILES_CREATE', data_send);

              // обновляем значения path и uuid в data
              el.audio.path = this.bot_uuid;
              el.audio.uuid = new_file.uuid;
          }
      }

      this.blocks    = blocks;
      this.cntBlocks = this.skill_item.mind_map_cnt ? this.skill_item.mind_map_cnt : '';

      this.loadModal = false;
      
      this.fetchData(true);

      return false;
    },

    async saveBlocks() {

      let data_send = {
          'name' : this.skill_name,
          'description' : this.skill_description,
      };

      let new_skill = '';
      new_skill = await this.$store.dispatch('skills/FETCH_SKILLS_CREATE', data_send);

      let mind_map = [];

      let cnt = 0;
      for (const el of this.blocks) {

          // let block_data = this.$refs['block_' + el.id][0];
          // let data = block_data.getData();
          let data = el;

          // Копируем файлы в skills

          let type = '';
          let path_from = '';
          if(this.bot_uuid === null){
            type = 'skills';
            path_from = this.skill_uuid;
          } else {
            type = 'bots';
            path_from = this.bot_uuid;
          }

          if(data.audio.filename && data.audio.filename !== null){
              // копируем физически
              data_send = {
                  attaching_type_to   : 'skills',
                  attaching_type_from : type,
                  path_to   : new_skill.uuid,
                  path_from : path_from,
                  filename  : data.audio.filename,
                  action    : 'copy'
              }

              let query_url = 'https://api.client.za-bota.com/uploads/';
              let response = await requestFunctions.sendDataAsync(query_url, data_send, 'POST');

              // создаем в базе с новым path
              data_send = {
                  title    : data.audio.title,
                  path     : new_skill.uuid,
                  status   : 'success',
                  ext      : data.audio.ext,
                  filename : data.audio.filename,
                  attaching_uuid : new_skill.uuid,
                  attaching_type : 'skills'
              }

              let new_file = await this.$store.dispatch('files/FETCH_FILES_CREATE', data_send);

              // обновляем значения path и uuid в data
              data.audio.path = new_skill.uuid;
              data.audio.uuid = new_file.uuid;
          }

          mind_map.push(data);
      };

      data_send = {
          'uuid' : new_skill.uuid,
          'mind_map' : JSON.stringify(mind_map),
          'version' : 2,
          'mind_map_cnt' : this.cntBlocks,
      };

      let result = await this.$store.dispatch('skills/FETCH_SKILLS_UPDATE', data_send);

      if(result === false){
          alert('Возникла ошибка');
      } else {
          this.saveModal = false;
          this.success_save_modal = true;
      }
    },

    showChannels(){
      this.showSidebarChannels = true;
    },
    showLoadSkill(){
      this.loadModal = true;
    }, 
    showSaveBlocks(){
      this.saveModal = true;
    }
  }
}
</script>

<template>
  <div class="full-screen-container">
    <Layout>
      <div class="mind-map-wrapper">
        <b-modal
            key="'test-call-modal'"
            v-model="modal.visible"
            centered
            size="md"
            :title="modal.title"
            title-class="font-18"
            hide-footer
        >
          <MindMapTestForm v-if="modal.visible && modal.type === 'testing'" @save="testingMap" @close="switchModal('close')" />
          <SkillForm v-if="modal.visible && modal.type === 'edite_skill'" :uuid="source.uuid" :action="'edite'" @close="switchModal('close', null, true)" />
          <BotForm v-if="modal.visible && modal.type === 'edite_bot'" :uuid="source.uuid" :action="'edite'" @close="switchModal('close', null, true)"/>
        </b-modal>

        <Header
            :title="source.title"
            @save="saveMap"
            @testing="switchModal('open', 'testing')"
            @edite="switchModal('open', 'editeSource')"
            @showChannels="showChannels"
            @showLoadSkill="showLoadSkill"
            @showSaveBlocks="showSaveBlocks"
            :owner_id="owner_id"
            :user_id="user_id"
            :bot_uuid="bot_uuid"
        />
        <DocBar
            :freeze="freeze"
            :fl_ai="fl_ai"
            @addBlock="addBlock"
        />
        <MindMap
            ref="mindMapRef"
            :key="key"
            :data="blocks"
            :select="selectedBlock.id"
            :track="track"
            :freeze="freeze"
            :fl_ai="fl_ai"
            @nodeEdit="editBlock"
            @nodeDelete="deleteBlock"
            @nodeCreate="addBlock"
            @nodeDragged="setBlockPosition"
            @changePathType="changePathType"
            @createPath="createPath"
            @editPath="editPath"
            @removePath="removePath"
        />
        <SideBar :visible="selectedBlock.visible" :title="'Редактировать узел'" :id="selectedBlock.id">
          <template v-if="selectedBlock.visible">
            <SkillsCard
                :key="selectedBlock.id"
                :block-id="selectedBlock.id"
                :params="selectedBlock.data.block"
                :target-path="selectedBlock.data.path || null"
                :type="selectedBlock.type"
                :bot_uuid="bot_uuid"
                :skill_uuid="skill_uuid"
                @save="applyBlockEdit"
                @close="closeSidebar"
            />
          </template>
        </SideBar>

        <SideBar :visible="showSidebarChannels" :title="'Каналы коммуникаций'">
            <BotChannels 
              v-if="showSidebarChannels"
              :bot_uuid="bot_uuid"
              @close="closeSidebar"
            />
        </SideBar>

        <b-modal
            v-model="saveModal"
            centered
            size="lg"
            title="Новый сценарий"
            title-class="font-18"
        >
            <b-form-group
                label="Название сценария"
                label-for="skill_name"
            >
                <b-form-input
                    id="skill_name"
                    v-model="skill_name"
                    placeholder="Укажите название нового сценария"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                label="Комментарий к сценарию"
                label-for="skill_description"
            >
                <b-form-input
                    id="skill_description"
                    v-model="skill_description"
                    placeholder=""
                ></b-form-input>
            </b-form-group>

            <template v-slot:modal-footer style="justify-content: flex-start !important">
                <div style="width: 100%">
                    <b-button variant="primary" class="btn" @click="saveBlocks" style="margin-right: 10px">Сохранить</b-button>
                    <b-button variant="light" class="btn" @click="saveModal = false"
                    >Отменить</b-button
                    >
                </div>
            </template>
        </b-modal>

        <b-modal
            v-model="loadModal"
            scrollable
            size="lg"
            title="Сценарии"
            title-class="font-18"
            hide-footer
        >
            <SkillsTable v-bind:is_popup="true" />
        </b-modal>

        <b-modal
            v-model="success_save_modal"
            centered
            hide-footer
            title="Успешно"
            title-class="font-18"
        >
            <div class="text-center">
                <i class="uil-sitemap text-success display-3" style="margin-bottom: 15px"></i>
                <h4 class="mt-4" style="margin-bottom: 15px">Сценарий успешно сохранен</h4>
                <p class="w-75 mx-auto text-muted">{{success_save_modal_text}}</p>
                <div class="mt-4">
                    <button
                        class="btn btn-outline-primary btn width-md"
                        style="margin-top: 15px"
                        @click="success_save_modal = false"
                    >
                        <i class="uil uil-arrow-left "></i> Вернуться
                    </button>
                </div>
            </div>
        </b-modal>

      </div>
    </Layout>
  </div>
</template>

<style scoped>
 .mind-map-wrapper {
   position: relative;
   width: 100%;
   height: 100%;
 }
</style>

<style>
.full-screen-container .content-page {
  padding: 0;
}

.full-screen-container .container-fluid {
  padding: 0;
}

.b-sidebar {
  background: #fff !important;
  box-shadow: none !important;
  border-left: 1px solid rgba(0, 0, 0, 0.125);
}

</style>